import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';

const FsHeaderSmall = withStyles(() =>
  createStyles({
    root: {},
  })
)((props) => <Typography variant="h3" component="h3" {...props} />);

export default FsHeaderSmall;
